import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ToastController } from '@freshworks/crayons/react';
import { InteropHostCallError } from 'errors';

/**
 * Centralized error handling for message-channel (interop host) calls.
 * Logs the error, shows the standard error toast and throws InteropHostCallError.
 *
 * Usage inside a catch block:
 *   catch (error) { handleInteropHostError(error, 'Failed to ...'); }
 */
const useInteropHostErrorHandler = () => {
  const { t } = useTranslation();

  return useCallback(
    (error, logMessage = 'Interop host call failed') => {
      console.error(logMessage, error);
      ToastController({ position: 'top-center', timeout: 5000 }).trigger({
        type: 'error',
        content: t('general.somethingWentWrong'),
      });
      throw new InteropHostCallError();
    },
    [t]
  );
};

export default useInteropHostErrorHandler;
